<template>
  <div class="d-flex">
    <v-row no-gutters style="flex-wrap: nowrap">
      <v-tooltip bottom :disabled="!label">
        <template #activator="{ on, attrs }">
          <div v-bind="attrs" style="width: 100%" v-on="on">
            <v-text-field
              v-model="searchValue"
              v-bind="$attrs"
              class="entsys--box searchbox"
              :label="inputLabel"
              :hint="hint"
              hide-no-data
              :hide-details="!hint"
              clearable
              outlined
              data-test="searchBox"
              v-on="$listeners"
            />
          </div>
        </template>
        <span>{{ label }}</span>
      </v-tooltip>

      <div class="searchbox-icon pl-0 ml-0">
        <div
          class="primary d-flex"
          style="height: 100%; border-radius: 0px 4px 4px 0px"
        >
          <v-icon color="white" style="margin:auto;">$iconSearch</v-icon>
        </div>
      </div>
    </v-row>
  </div>
</template>
<script>
import { defineComponent, ref, computed } from "vue";
export default defineComponent({
  name: "AppSearchBox",
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default() {
        return this.$t(
          "common:filters.search.tooltip.FilterWithTyping",
          "Please start typing a name (min 3 characters)",
          "Tooltip for filters, when user should start typing the name"
        );
      }
    },
    hint: {
      type: String,
      default: null
    },
    inputLabel: {
      type: String,
      default() {
        return this.$t(
          "common:search.input.label",
          "Search by keyword",
          "Label of the search field"
        );
      }
    },
    disableDelay: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const timeout = ref(null);

    const searchValue = computed({
      get() {
        return props.value;
      },
      set(v) {
        if (props.disableDelay) {
          ctx.emit("update:value", v || null);
          return;
        }
        // Clear timeout, even if active
        clearTimeout(timeout.value);
        if (v) {
          timeout.value = setTimeout(() => {
            ctx.emit("update:value", v);
          }, 750);
        } else {
          ctx.emit("update:value", null);
        }
      }
    });

    return {
      searchValue
    };
  }
});
</script>
<style lang="scss">
.searchbox-icon {
  width: 54px;
  height: 48px;
  @media (max-width: 960px) {
    & {
      width: 45px;
    }
  }
}
.searchbox {
  &.v-text-field--outlined {
    border-radius: 4px 0 0 4px;
  }
  label {
    color: #1c2f5e !important;
  }
  .v-input__icon--clear {
    transform: translateY(-5px);
  }
}
</style>
